import React from 'react';

export default {
  width: 11,
  height: 14,
  content: (
    <path d="M5.786 12.64l-.768.92-.768-.92C1.438 9.273.018 6.789.018 5a5 5 0 0 1 10 0c0 1.788-1.42 4.272-4.232 7.64zM8.018 5a3 3 0 1 0-6 0c0 1.033.994 2.884 3 5.416 2.006-2.532 3-4.383 3-5.416z M5.017 5.999a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
  )
};
